import { render } from "./articles-association.vue?vue&type=template&id=4fbbb654&scoped=true"
import script from "./articles-association.vue?vue&type=script&lang=js"
export * from "./articles-association.vue?vue&type=script&lang=js"

import "./articles-association.vue?vue&type=style&index=0&id=4fbbb654&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fbbb654"]])

export default __exports__